module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.2809/js/img/peopleBlobs/gyasi.png"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/peopleBlobs/gyasi.png
// module id = 732
// module chunks = 3 4